import CountryAccordion from '@/components/dashboard/CountryAccordion'

// ==================== AssignedCompliancesStatus ====================
// Top-level list: renders a CountryAccordion per country. All nested
// data-fetching, pagination, and editing lives in the child accordions.
const AssignedCompliancesStatus = ({
  countries = [],
  periodRange,
  onComplianceUpdated,
}) => {
  return (
    <>
      {countries.map(country => (
        <CountryAccordion
          key={country.countryCode}
          country={country}
          periodRange={periodRange}
          onComplianceUpdated={onComplianceUpdated}
        />
      ))}
    </>
  )
}

export default AssignedCompliancesStatus
